import styled from 'styled-components'
import { themeColor, themeFontWeight } from '@elparking/components'

const DEFAULT_LABEL_FONT_SIZE = '9px'
const DEFAULT_LABEL_HEIGHT = '12px'

const mediaScreenMobile = props => `@media screen and (max-width: ${props.theme.screens.medium})`

export const Label = styled.label`
    display: block;
    font-weight: ${themeFontWeight('medium')};
    font-size: ${DEFAULT_LABEL_FONT_SIZE};
    text-transform: uppercase;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-bottom: 4px;
    white-space: nowrap;
    color: ${themeColor('gray')};
    width: 100%;
    margin: 0;
    height: ${DEFAULT_LABEL_HEIGHT};

    ${mediaScreenMobile} {
        display: none;
    }
`
